module.exports = __webpack_public_path__ + "static/media/007ty@4x.0edc1845.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/007ty@4x.png
// module id = 414
// module chunks = 0 1